/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-attached-file/bulbattachedfile
 */

import { Plugin } from 'ckeditor5';
import BulbAttachedFileEditing from './bulbattachedfileediting';
import BulbAttachedFileUI from './bulbattachedfileui';
import BulbAttachedFileToolbar from './bulbattachedfiletoolbar';

/**
 * The attached file plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbAttachedFile extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbAttachedFileEditing, BulbAttachedFileUI, BulbAttachedFileToolbar] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbAttachedFile' as const;
  }
}
